var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":"signInDialogue","size":"sm","centered":"","hide-header":"","hide-footer":"","no-close-on-backdrop":""}},[_c('SignInForm',{on:{"is-authenticated":_vm.onAuthenticated}}),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back to home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }